import {
  UPDATE_TRAP_SITE_SETTINGS,
  UPDATE_COLLECTION_METHOD_SETTINGS,
  UPDATE_TRAY_SETTINGS,
  FINISH_CAPTURE,
  SET_METADATA_ERRORS,
  SET_TRAP_SITE_LOADING,
  SET_COLLECTION_METHOD_LOADING,
  SET_TRAY_LOADING,
  UPDATE_DEVICE_SETTINGS,
  UPDATE_USER_SETTINGS
} from "../actions/types";
import _ from "lodash";

export const DEFAULT_DATA_SETTINGS = {
  Tray: {
    page: 0,
    pageSize: 25,
    orderBy: "createdOn",
    order: "desc",
    rowsPerPageOptions: [10, 25, 50],
    loading: false,
  },
  "Collection Site": {
    page: 0,
    pageSize: 15,
    orderBy: "displayName",
    order: "asc",
    rowsPerPageOptions: [10, 15, 50],
    loading: false,
  },
  "Collection Method": {
    page: 0,
    pageSize: 15,
    orderBy: "displayName",
    order: "asc",
    rowsPerPageOptions: [10, 15, 50],
    loading: false,
  },
  "Devices": {
    page: 0,
    pageSize: 25,
    orderBy: "uuid",
    order: "asc",
    rowsPerPageOptions: [10, 25, 50],
    loading: false,
  },
  "Users": {
    page: 0,
    pageSize: 25,
    orderBy: "email",
    order: "asc",
    rowsPerPageOptions: [10, 25, 50],
    loading: false,
  },
  displayMetadataErrors: false,
};

/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (state = DEFAULT_DATA_SETTINGS, action) => {
  switch (action.type) {
    case UPDATE_TRAP_SITE_SETTINGS:
      return _.defaultsDeep({}, { "Collection Site": action.payload }, state);
    case UPDATE_COLLECTION_METHOD_SETTINGS:
      return _.defaultsDeep({}, { "Collection Method": action.payload }, state);
    case UPDATE_USER_SETTINGS:
      return _.defaultsDeep({}, { "Users": action.payload }, state);
    case UPDATE_DEVICE_SETTINGS:
      return _.defaultsDeep({}, { "Devices": action.payload }, state);
    case UPDATE_TRAY_SETTINGS:
      return _.defaultsDeep({}, { Tray: action.payload }, state);
    case FINISH_CAPTURE:
      return { ...state, displayMetadataErrors: false };
    case SET_METADATA_ERRORS:
      return { ...state, displayMetadataErrors: action.payload };
    case SET_TRAP_SITE_LOADING:
      return _.defaultsDeep(
        {},
        { "Collection Site": { loading: action.payload } },
        state
      );
    case SET_COLLECTION_METHOD_LOADING:
      return _.defaultsDeep(
        {},
        { "Collection Method": { loading: action.payload } },
        state
      );

    case SET_TRAY_LOADING:
      return _.defaultsDeep({}, { Tray: { loading: action.payload } }, state);
    default:
      return state;
  }
};
